<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2">
            <v-icon left style="margin-right:0">mdi-chevron-left</v-icon>返回
          </span>
        </div>
        <v-card class="form-card card-padding">
          <h2 class="card-title">查看组件</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
            <v-tab v-if="component.comType===1" key="apps">绑定应用</v-tab>
          </v-tabs>
          <v-card-text>
            <!-- <p>{{form}}</p> -->
            <v-form v-show="tabValue === 0" ref="form">
              <ul  class="form-ul label-width-9">
                <li>
                  <span class="label">组件comCode：</span>
                  <div class="text"> {{component.comCode}}
                  </div>
                </li>
                <li>
                  <span class="label">名称：</span>
                  <div class="text"> {{component.comName}}
                  </div>
                </li>
                <li>
                  <span class="label">英文名称：</span>
                  <div class="text"> {{component.nameEn}}
                  </div>
                </li>
                <li>
                  <span class="label">组件类型：</span>
                  <div :class="'text ' + colorText[component.comType - 1]">
                    {{component.comType ? componentTypeList.find(e => e.id === component.comType).name : ''}}
                  </div>
                </li>
                <li>
                  <span class="label">用户类型：</span>
                  <div class="text">
                    <!-- {{component.userType ? userTypeList.find(e => e.label === component.userType).name : ''}} -->
                    <span v-if="component.userType === 'common'" >
                      <!-- {{ item.userType }} -->
                      <span v-for="(item, i) in userTypeList" :key="i">
                        {{ item.name }}
                        <span v-if="i + 1 < userTypeList.length">&nbsp;/&nbsp;</span>
                      </span>
                    </span>
                    <span v-else-if="component.userType">
                      {{ userTypeList.find((e) => e.label === component.userType).name }}
                    </span>
                  </div>
                </li>
                <li>
                  <span class="label">平台类型：</span>
                  <div class="text">
                    {{component.platType ? platTypeList.find(e => e.code === component.platType).name : ''}}
                  </div>
                </li>
                <template v-if="component.comType === 1">
                  <li>
                    <span class="label">应用图标目录：</span>
                    <div class="text"> {{component.appIconStyle}}
                    </div>
                  </li>
                  <li>
                    <span class="label">使用默认主题图标：</span>
                    <div class="text"> {{component.defaultTheme ? '优先使用默认主题图标' : '优先使用自定义主题图标'}}
                    </div>
                  </li>
                  <li>
                    <span class="label">组件显示应用数量：</span>
                    <div class="text"> {{component.appsCount}}
                    </div>
                  </li>
                  <li>
                    <span class="label">是否显示全部应用：</span>
                    <div class="text"> {{component.isAllApps ? '显示' : '不显示'}}
                    </div>
                  </li>
                </template>
                <li class="li-file">
                  <span class="label">组件图示：</span>
                  <div class="text">
                     <img class="component-img" v-if="component.comIconUrl" :src="component.comIconUrl" alt="img">
                  </div>
                </li>
                <li>
                  <span class="label">说明：</span>
                  <div class="text"> {{component.description}}
                  </div>
                </li>
              </ul>
            </v-form>
            <!-- <p>{{component}}</p> -->
            <detail-app-list v-show="tabValue === 1" :data="component"></detail-app-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
// detailAppList
import detailAppList from './module/detailAppList.vue'
export default {
  components: {
    detailAppList
  },
  data () {
    return {
      colorText: ['indigo--text', 'deep-orange--text', 'teal--text'],
      tabValue: 0,
      component: JSON.parse(sessionStorage.getItem('componentDetail'))
    }
  },
  computed: {
    ...mapState(['platTypeList', 'userTypeList', 'componentTypeList', 'iconDirectoryList'])
  },
  watch: {
  },
  beforeDestroy () {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    back () {
      this.$router.back(-1)
      sessionStorage.removeItem('componentDetail')
    }
  }
}
</script>
<style>
.v-slider__thumb {
  cursor: pointer;
}
</style>
